import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use"];
import { PercentageInput } from 'foundations-components/transitional/components/PercentageInput';
import UIPercentageInput from 'UIComponents/input/UIPercentageInput';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { createTokenizedComponent, withoutClassName } from './helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export let _capturedPropsForTesting = {};
const TokenizedPercentageInput = createTokenizedComponent(UIPercentageInput);
export default function PercentageInputAdapter(_ref) {
  let {
      use
    } = _ref,
    commonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (isUngatedForDisplayOptimizedFormControl) {
    const rest = withoutClassName(commonProps);
    _capturedPropsForTesting = Object.assign({
      use
    }, rest);
    return /*#__PURE__*/_jsx(PercentageInput, Object.assign({
      "data-test-id": "PercentageInput",
      use: use
    }, rest));
  }
  const adaptedUse = use === 'default' || use === 'on-dark' ? use : undefined;
  _capturedPropsForTesting = Object.assign({
    use: adaptedUse
  }, commonProps);
  return /*#__PURE__*/_jsx(TokenizedPercentageInput, Object.assign({
    "data-test-id": "UIPercentageInput",
    use: adaptedUse
  }, commonProps));
}